import { Component, effect, inject, input } from '@angular/core';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { TableColumn } from '../../../../modules/shared/components/kit/table/table.types';
import { translate } from '../../../../modules/shared/shared.global-service';
import { TranslatePipe } from '@ngx-translate/core';
import { FilterBuilder } from '../../../../modules/content/helper/filter.builder';
import { VatCodeLineObject } from '@libs/types/src/mado/object-type/organization';
import { OrganizationSettingsVatCodeLineStore } from './organization-settings-vat-code-line.store';
import { vatCodeLineFrag } from './organization-settings-vat-code-line.query';
import {
    OrganizationSettingsVatCodeLineDialogComponent,
} from './dialog/organization-settings-vat-code-line-dialog.component';
import { madoAccountToDropdownOptionString } from 'packages/client/src/app/utils/mado/account.utils';
import { BaseDialogService } from '../../../kit/base-dialog/base-dialog-service';
import { TableComponent } from 'packages/client/src/app/modules/shared/components/kit/table/table.component';

@Component({
    selector: 'app-organization-settings-vat-code-line',
    templateUrl: './organization-settings-vat-code-line.component.html',
    providers: [OrganizationSettingsVatCodeLineStore],
    imports: [
        TranslatePipe,
        PrimeTemplate,
        TableComponent,
    ],
})
export class OrganizationSettingsVatCodeLineComponent {
    protected readonly store = inject(OrganizationSettingsVatCodeLineStore);
    protected readonly dialogService = inject(BaseDialogService);

    protected readonly vatCodeId = input<number>();

    protected readonly prefix = 'organization-settings.mado.vatCodeLine.';

    protected columns: TableColumn[] = [
        {
            name: 'type',
        },
        {
            name: 'entryType',
        },
        {
            name: 'percentage',
        },
        {
            name: 'accountId',
        },
    ];

    constructor() {
        effect(() => {
            this.loadVatCodeLines();
        });
    }

    openDialog(vatCodeLine: VatCodeLineObject | null = null) {
        const header = `${this.prefix}title` + (vatCodeLine ? 'Detail' : 'Create');
        const dialog = this.dialogService.open(
            OrganizationSettingsVatCodeLineDialogComponent,
            {
                header: translate.instant(header),
                data: { vatCodeLine, vatCodeId: this.vatCodeId() },
            },
        );

        dialog?.onClose.subscribe((it) => {
            if (it === true) {
                this.loadVatCodeLines();
            }
        });
    }

    async loadVatCodeLines() {
        await this.store.api.getVatCodeLines(FilterBuilder.singlePage({ vatCodeId: this.vatCodeId() }), vatCodeLineFrag);
    }

    protected readonly madoAccountToDropdownOptionString = madoAccountToDropdownOptionString;
}
